import { useNavigate } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import classNames from 'classnames';
import { Avatar } from '@/components';

interface AdvisorProps {
	advisorId: string;
	name: string;
	specialties: string;
	avatarUrl?: string;
	bio?: string;
	bookingsUrl?: string;
	className?: string;
	hasPublications?: boolean;
	jobTitle?: string;
}

export const Advisor = ({
	advisorId,
	name,
	specialties,
	avatarUrl,
	bio,
	bookingsUrl,
	className,
	hasPublications,
	jobTitle,
}: AdvisorProps) => {
	const navigate = useNavigate();

	return (
		<div className={className}>
			<div className="d-flex align-items-center">
				<Avatar className="mr-6" size={86} url={avatarUrl} />
				<div>
					{jobTitle && <h3 className="small text-muted text-uppercase">{jobTitle}</h3>}
					<h2 className="h3">{name}</h2>
					<p className="mb-0">{specialties}</p>
				</div>
			</div>
			{bio && <div className="mt-4 mb-0" dangerouslySetInnerHTML={{ __html: bio ?? '' }} />}
			<div className={classNames('d-flex align-items-center', { 'mt-6': bookingsUrl || hasPublications })}>
				{bookingsUrl && (
					<Button
						variant="outline-primary"
						className="mr-2"
						href={bookingsUrl}
						target="_blank"
						rel="noopener"
					>
						Schedule a Meeting
					</Button>
				)}
				{hasPublications && (
					<Button
						variant="outline-primary"
						onClick={() => {
							navigate(`/advisory-team/${advisorId}`);
						}}
					>
						View Publications
					</Button>
				)}
			</div>
		</div>
	);
};
